import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Card } from 'antd';
import Swal from 'sweetalert2';
import { SIMULATION_COUNTRY_STATES } from '../../../data';
import ApiService from '../../../services/ApiService';
import DataService from '../../../services/DataService';
import SocketService from '../../../services/SocketService';
import { Page } from './styles';

export const CountrySummary = () => {
  const params = useParams();
  const navigate = useNavigate();
  const countryList = DataService.getItem('countryList');
  const [simulationCountry, setSimulationCountry] = useState(null);
  const wasInUseRef = useRef(false);

  const fetchCountry = async () => {
    const data = await ApiService.retrieveSimulationCountry(params.simulationCountryId);
    if (!data.success) {
      navigate('/portal/welcome');
      return;
    }

    if (wasInUseRef.current && !data.result.inUse) {
      Swal.fire({
        title: 'Country Available',
        icon: 'success',
        text: 'This country is no longer in use. You can enter now.',
        toast: true,
        position: 'top-end',
        timer: 5000,
        showConfirmButton: false,
      });
    }

    wasInUseRef.current = !!data.result.inUse;
    setSimulationCountry(data.result);
  };

  const handleEnterCountry = () => {
    if (simulationCountry.inUse) {
      SocketService.emit('waiting-for-sc', params.simulationCountryId);
      Swal.fire({
        title: 'Simulation Country in Use',
        icon: 'info',
        html:
          'This simulation country is already being used by another student. Please wait until your country is available.<br /><br />' +
          'The <b>In Use</b> label will disappear when the country is free, and you will see a notification here.',
      });
      return;
    }

    if (simulationCountry.simulationCountryState === SIMULATION_COUNTRY_STATES.NEW) {
      navigate(`/portal/simulations/${simulationCountry.simulationCountryId}/welcome`);
    } else if (simulationCountry.simulationCountryState === SIMULATION_COUNTRY_STATES.IN_YEAR_ATTACKED_ANOTHER) {
      navigate(`/portal/simulations/${simulationCountry.simulationCountryId}/military?war=true`);
    } else if (simulationCountry.simulationCountryState === SIMULATION_COUNTRY_STATES.IN_YEAR_ATTACKED_BY_ANOTHER) {
      navigate(`/portal/simulations/${simulationCountry.simulationCountryId}/military?war=true`);
    } else {
      navigate(`/portal/simulations/${simulationCountry.simulationCountryId}/national-briefing`);
    }
  };

  useEffect(() => {
    SocketService.on('start-playing-sc', simulationCountryId => {
      if (+params.simulationCountryId === +simulationCountryId) {
        fetchCountry();
      }
    });
    SocketService.on('stop-playing-sc', simulationCountryId => {
      if (+params.simulationCountryId === +simulationCountryId) {
        fetchCountry();
      }
    });

    return () => {
      SocketService.off('start-playing-sc');
      SocketService.off('stop-playing-sc');
    };
  }, []);

  useEffect(() => {
    fetchCountry();
    // eslint-disable-next-line
  }, [params.simulationCountryId]);

  if (!simulationCountry) {
    return null;
  }

  const country = countryList.find(c => c.countryId === simulationCountry.countryId);

  return (
    <Page>
      <Card>
        <h2>{simulationCountry.countryName}</h2>
        <hr />
        <div className="year">
          <img src={`/images/flags/${country.countryCode}.png`} alt=""></img>
          <span>Year {simulationCountry.simulationCountryYear}</span>
        </div>
        <hr />
        <img className="img-earth" src="/images/pages/portal/country-summary/earth.png" alt="" />
        <div></div>
        <Button type="primary" onClick={handleEnterCountry}>
          {simulationCountry.inUse ? 'In Use — Please Wait' : 'Enter Country'}
        </Button>
      </Card>
    </Page>
  );
};
